import {AfterViewInit, Component, ElementRef, Input, OnDestroy} from '@angular/core';
import { SpinnerColorDirective } from '../../directives/spinner-color.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf, NgStyle } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrls: ['./progress-spinner.component.scss'],
    standalone: true,
    imports: [NgIf, NgStyle, MatProgressSpinnerModule, SpinnerColorDirective]
})
export class ProgressSpinnerComponent implements AfterViewInit, OnDestroy {

  @Input()
  color?: string;
  @Input()
  backgroundColor?: string;
  @Input()
  value?: number;
  @Input()
  diametr: number = 50;
  @Input()
  strokeWidth?: number = 8;
  @Input() isHeader: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(private elementRef: ElementRef) {
  }

  ngAfterViewInit(): void {
    const spinners: HTMLCollection = this.elementRef.nativeElement.getElementsByClassName('mdc-circular-progress__determinate-circle-graphic');
    Array.from(spinners).forEach (spinner => {
       const viewBox = spinner.getAttribute('viewBox');
       if(viewBox) {
        const values = viewBox.split(' ').map(v => +v + (+v * 5 / 100));
        if(values) {
          spinner.setAttribute('viewBox', values.join(' '))
        }
       }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
